import { useEffect, useState } from "react";
import { useGetJourneyCardsQuery } from "../../../graphql/operations/trialMode/journeyCard/get-journey-cards";
import ContentTitle from "../../../components/ui/ContentTitle";
import TableCustom from "../../../components/ui/TableCustom";
import Spinner from "../../../components/layout/spinner/Spinner";
import MarketDropdown from "../../../components/ui/MarketDropdown";
import getInitialMarket from "../../../utils/getInitialMarket";
import errorMessage from "../utils/errorMessage";
import withUserPrograms from "../withUserPrograms";
import { MarketType } from "../types";
import normalizeJourneyCardData from "./utils/normalizeJourneyCardData";
import EditForm from "./editForm/EditForm";
import { createColumns } from "./columns";
import { JourneyCardType } from "./types";
import "./JourneyCard.scss";

function JourneyCard() {
  const initialMarket = getInitialMarket();

  const [selectedMarket, setSelectedMarket] =
    useState<MarketType>(initialMarket);
  const [dataSource, setDataSource] = useState<JourneyCardType[]>([]);
  const [marketData, setMarketData] = useState<JourneyCardType[]>([]);
  const [editingData, setEditingData] = useState<JourneyCardType | null>(null);

  const {
    data,
    loading: loadingOfGet,
    error: errorOfGet,
    refetch,
  } = useGetJourneyCardsQuery({
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (data) setDataSource(normalizeJourneyCardData(data));
  }, [data]);

  useEffect(() => {
    setMarketData(dataSource.filter(({ market }) => market === selectedMarket));
  }, [dataSource, selectedMarket]);

  if (errorOfGet) errorMessage();
  if (loadingOfGet) return <Spinner />;

  return (
    <div id="JourneyCardWrapper">
      <ContentTitle
        title="Journey Card"
        returnTitle="Journey card detail"
        onReturn={editingData ? () => setEditingData(null) : undefined}
      />

      <div className="mx-6 pt-5 pb-24">
        <div className="min-w-[1084px] px-6 bg-white">
          {editingData ? (
            <div className="py-6">
              <EditForm
                data={editingData}
                setEditingData={setEditingData}
                refetch={refetch}
              />
            </div>
          ) : (
            <>
              <div className="h-16 flex flex-row-reverse px-2 py-4">
                <MarketDropdown
                  selectedMarket={selectedMarket}
                  setSelectedMarket={setSelectedMarket}
                />
              </div>

              <TableCustom
                className="custom-table-style"
                dataSource={marketData}
                columns={createColumns(setEditingData)}
                pagination={false}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default withUserPrograms(JourneyCard, "Journey Card");
